<template>
  <fragment>
    <div class="confectionModal">
      <div class="confectionModal-top">
        <img class="confectionModal-image img-responsive" alt="envelope example" :src="image">
      </div>

      <div class="confectionModal-content">
        <h2 class="confectionModal-title">Ozdobne świąteczne etui na kartę</h2>
        <section class="confectionModal-descriptions">
          <p>
            Zamień zwykły upominek w prawdziwą świąteczną niespodziankę! Świąteczne etui na kartę Pluxee, z uroczym motywem piernika, sprawia, że każda chwila wręczania prezentu staje się wyjątkowa. To drobny dodatek, który wzmacnia efekt WOW i dodaje ciepła do każdej karty. Zamów już dziś i podaruj odrobinę świątecznej magii!
          </p>
        </section>
      </div>
    </div>
  </fragment>
</template>

<script>
export default {
  name: 'NDEEtuiCardChristmasModal',
  props: {
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
